export default "__VITE_PUBLIC_ASSET__cb8a81c6__"